/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { otelGetEventFacets } from "../funcs/otelGetEventFacets.js";
import { otelGetEventVolume } from "../funcs/otelGetEventVolume.js";
import { otelListEventLog } from "../funcs/otelListEventLog.js";
import { otelUploadLogs } from "../funcs/otelUploadLogs.js";
import { otelUploadMetrics } from "../funcs/otelUploadMetrics.js";
import { otelUploadTraces } from "../funcs/otelUploadTraces.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GetEventFacetsResult } from "../models/components/geteventfacetsresult.js";
import { GetEventVolumeResult } from "../models/components/geteventvolumeresult.js";
import { ListEventLogResult } from "../models/components/listeventlogresult.js";
import {
  GetEventFacetsRequest,
  GetEventFacetsSecurity,
} from "../models/operations/geteventfacets.js";
import {
  GetEventVolumeRequest,
  GetEventVolumeSecurity,
} from "../models/operations/geteventvolume.js";
import {
  ListEventLogRequest,
  ListEventLogSecurity,
} from "../models/operations/listeventlog.js";
import {
  UploadLogsRequest,
  UploadLogsSecurity,
} from "../models/operations/uploadlogs.js";
import {
  UploadMetricsRequest,
  UploadMetricsSecurity,
} from "../models/operations/uploadmetrics.js";
import {
  UploadTracesRequest,
  UploadTracesSecurity,
} from "../models/operations/uploadtraces.js";
import { unwrapAsync } from "../types/fp.js";

export class Otel extends ClientSDK {
  /**
   * logs otel
   *
   * @remarks
   * Endpoint to receive OTEL logs data from LLM providers and harnesses.
   */
  async uploadLogs(
    request?: UploadLogsRequest | undefined,
    security?: UploadLogsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(otelUploadLogs(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * metrics otel
   *
   * @remarks
   * Endpoint to receive OTEL metrics data from LLM providers and harnesses.
   */
  async uploadMetrics(
    request?: UploadMetricsRequest | undefined,
    security?: UploadMetricsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(otelUploadMetrics(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * traces otel
   *
   * @remarks
   * Endpoint to receive OTEL traces data from LLM providers and harnesses.
   */
  async uploadTraces(
    request?: UploadTracesRequest | undefined,
    security?: UploadTracesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(otelUploadTraces(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getEventFacets otel
   *
   * @remarks
   * Org-scoped filter facets for the event feed: the distinct sources and event/span names observed in a time range.
   */
  async getEventFacets(
    request: GetEventFacetsRequest,
    security?: GetEventFacetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetEventFacetsResult> {
    return unwrapAsync(otelGetEventFacets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getEventVolume otel
   *
   * @remarks
   * Org-scoped event volume timeseries for the event feed: bucketed counts of ingested OpenTelemetry log records vs spans over a time range, honoring the same filters as listEventLog.
   */
  async getEventVolume(
    request: GetEventVolumeRequest,
    security?: GetEventVolumeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetEventVolumeResult> {
    return unwrapAsync(otelGetEventVolume(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listEventLog otel
   *
   * @remarks
   * Org-scoped event feed over ingested OpenTelemetry signals: log records and spans merged into one reverse-chronological list with keyset pagination and a capped total count.
   */
  async listEventLog(
    request: ListEventLogRequest,
    security?: ListEventLogSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListEventLogResult> {
    return unwrapAsync(otelListEventLog(
      this,
      request,
      security,
      options,
    ));
  }
}
